import { useState } from "react";
import "./style.css";

export const Input = ({ id, autoComplete, inputMode, disabled, placeholder, onKeyPress, defaultValue, type = "text", icon, iconType = null, classname = "", iconPositionRight = true }) => {
  const [inputType, setInputType] = useState(type);

  const handleIcon = () => {
    if (iconType === "tooglePasswordVisibility") {
      inputType === "text" ? setInputType("password") : setInputType("text");
    }
  };

  const iconAction = iconType === null ? "" : " actionIcon ";
  const inputSpaceAtStart = iconPositionRight ? "" : " inputSpaceAtStart ";

  const renderIcon = (className) => iconType === "tooglePasswordVisibility" ? (
    <button type="button" className={className} onClick={handleIcon} disabled={Boolean(disabled)}
      aria-label={inputType === "password" ? "Mostrar contraseña" : "Ocultar contraseña"}
      aria-pressed={inputType === "text"} style={{background: "none", border: 0, padding: 0}}>{icon}</button>
  ) : <span className={className} aria-hidden="true">{icon}</span>;
  return (
    <div className="input-container">
      {!iconPositionRight && renderIcon(" iconLeft " + iconAction)}
      <input
        id={id}
        autoComplete={autoComplete}
        inputMode={inputMode}
        defaultValue={defaultValue}
        type={inputType}
        placeholder={placeholder}
        disabled={disabled}
        onKeyPress={onKeyPress}
        className={`${classname} ${inputSpaceAtStart} ${iconPositionRight ? "" : "inputSpaceAtStart"}`}
      />
      {iconPositionRight && renderIcon(" inputRight " + iconAction)}
    </div>
  );
};
